// Copyright (c) StrangeBee 2023

import { QuickFiltersAvailable } from '@Hooks/useQuickFilters';
import StatsCard from '@Molecules/StatsCard/StatsCard';
import React, { ReactElement } from 'react';
import { WidgetOutput, ObjectTypeV1 } from 'thehive-sdk';
import { useLocalMessage } from '@Helpers/locale';

import './AlertStats.scss';

interface AlertStatsProps {
    quickFilters: QuickFiltersAvailable;
}

const AlertStats = ({ quickFilters }: AlertStatsProps): ReactElement => {
    const i = useLocalMessage();

    const { status: filterStatus, custom: filterCustom } = quickFilters;

    const statusWidget: WidgetOutput = {
        id: 'alert-stats-status',
        type: 'donut',
        options: {
            stacked: false,
            field: 'status',
            filters: [],
            entity: ObjectTypeV1.ALERT,
            periodDateField: '_createdAt',
        },
    };

    const typeWidget: WidgetOutput = {
        id: 'alert-stats-type',
        type: 'donut',
        options: {
            stacked: false,
            field: 'type',
            filters: [],
            entity: ObjectTypeV1.ALERT,
            periodDateField: '_createdAt',
        },
    };

    return (
        <div className="alert-display-stats">
            <StatsCard
                widget={statusWidget}
                onItemClick={(value) => filterStatus(value)}
                title={i('alert.stats.status')}
            />

            <StatsCard
                widget={typeWidget}
                onItemClick={(value) =>
                    filterCustom({
                        field: 'type',
                        operator: 'any',
                        values: [value],
                    })
                }
                title={i('alert.stats.type')}
            />
        </div>
    );
};

export default AlertStats;
